(function () {
    'use strict'

    var smallGalleryController = function ($document, $timeout, $element, $scope) {
        var ctrl = this;

        //Internal variables
        var _init = false;
        var _f = 'function';

        var _sliderElement = null;
        var _viewportElement = null;

        ctrl.ux = {
            slideOffset: 0,
            maxMove: 0,
        };

        var _selectedSlideIndex = 0;
        var _maxStartSlideIndex = 0;

        var _$slideChildren = null;

        function getWidth() {
            var computedViewportStyle = getComputedStyle(_viewportElement[0]); // Access the style to get the current margin

            ctrl.ux.maxMove = (_sliderElement.innerWidth() - _viewportElement.innerWidth()) + parseInt(computedViewportStyle.paddingLeft);

            // If no max start slide index defined, calculate it now.
            if (_maxStartSlideIndex == 0 && ctrl.ux.maxMove >= 0) {

                var maxCount = _$slideChildren.length;

                // Get the x coordinate of every image element until we hit the first that goes beyond the maxmove,
                // and store this as the maximum slide index for navigation
                for (var i = 0; i < maxCount; i++) {
                    var elem = $(_$slideChildren[i]);
                    // If this element is after the max move position, flag it as the limit
                    if (elem.position().left > ctrl.ux.maxMove) {
                        _maxStartSlideIndex = i;
                        break;
                    }
                }
            }

        }
        
        function goToSlideIndex(index) {
            getWidth();
            // Limit to the length of the array
            var potentialSlideIndex = Math.max(0, Math.min(index, ctrl.images.length - 1));

            // Limit to the first possible displayed slide in the list (makes it so that
            // the slides showing beyond the first don't require multiple clicks to get back
            // to the start to begin moving again.

            // Make the selected slide index no 
            _selectedSlideIndex = Math.min(potentialSlideIndex, _maxStartSlideIndex);

            // Get the scroll position of the slide we want to go to (even if it would be farther than the start of
            // the viewport once the end is near)
            var scrollTo = $(_$slideChildren[potentialSlideIndex]);

            // This makes the translation move in the opposite direction to the increment
            // but it is restricted to the maximum and minimum
            // The min part stops it going beyond the maxMove, and the max part stops it going less than zero.
            ctrl.ux.slideOffset = (Math.max(0, Math.min(!!scrollTo.length ? scrollTo.position().left : 0, ctrl.ux.maxMove)));

            _sliderElement[0].style.transform = 'translateX(' + -ctrl.ux.slideOffset + 'px)';
        };

        ctrl.util = tios.util;

        ctrl.slide = function (positive) {
            getWidth();

            // Can perform the move if positive and not at the right hand limit,
            // or if not positive and not at the left hand limit
            if ((positive && ctrl.ux.slideOffset !== ctrl.ux.maxMove) || (!positive && ctrl.ux.slideOffset !== 0)) {
                goToSlideIndex(_selectedSlideIndex + (positive ? 1 : -1));// Get the increment dependent on the direction
            }

        };

        ctrl.pickImage = function (item, index) {
            ctrl.onSelect({ $event: { item: item, index: index } });
        };

        //Init function
        ctrl.$onInit = init;

        ctrl.$onChanges = function (changes) {
            if (_init) {

                // If images change, reset max start slide index for computation
                if (changes.images) {
                    _maxStartSlideIndex = 0;
                    getWidth();
                }

                // If the current image is changed after init (and it's within range), jump to it.
                if (changes.jumpTo != null && (ctrl.jumpTo >= 0 || ctrl.jumpTo < ctrl.images.length)) {
                    goToSlideIndex(ctrl.jumpTo);
                }
            }
        }

        //-

        function init() {
            //set up defaults

            // The timeout allows us to capture the elements after they've rendered
            $timeout(function () {

                _viewportElement = $element.find('#viewport');
                _sliderElement = _viewportElement.find('#slider');

                _$slideChildren = _sliderElement.children('img');

                getWidth();
            });

            _init = true;

        }
    };

    app.component('smallgallery', {

        bindings: {
            jumpTo: '<?', // Optional, image to jump to when external gallery is selected (do so only after init)(
            images: '<', // Array of image strings
            onSelect: '&' // what to do when image is selected
        },

        controller: ['$document', '$timeout', '$element', smallGalleryController],
        controllerAs: 'ctrl',

        templateUrl: (typeof (tios) !== 'undefined' ? tios.util.cdnUrl('dist/angular/component/smallgallery.html') : 'component/smallgallery.html')
    });
})();